import "@/App.css";
import "@/styles/spreadsheet-grid.css";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/auth/AuthContext";
import ProtectedRoute from "@/auth/ProtectedRoute";
import GuardedRoute from "@/auth/GuardedRoute";
import LoginPage from "@/pages/LoginPage";
import ExceptionDesk from "@/pages/ExceptionDesk";
import ProjectAcceptancePage from "@/pages/ProjectAcceptancePage";
import ActiveJobWorkspacePage from "@/pages/ActiveJobWorkspacePage";
import MasterBoardPage from "@/pages/MasterBoardPage";
import ManagerBoard from "@/pages/ManagerBoard";
import ClosedProjectsPage from "@/pages/ClosedProjectsPage";
import DeletedProjectsPage from "@/pages/DeletedProjectsPage";
import InvoiceWorkspace from "@/pages/InvoiceWorkspace";
import PlatformCompaniesPage from "@/pages/PlatformCompaniesPage";
import ActionAiAssistantPage from "@/pages/ActionAiAssistantPage";
import ProductionTrackerPage from "@/pages/ProductionTrackerPage";
import PasswordChangePage from "@/pages/PasswordChangePage";
import UserManagementPage from "@/pages/UserManagementPage";
import ActionQueuePage from "@/pages/ActionQueuePage";
import CommunicationLogWorkspacePage from "@/pages/CommunicationLogWorkspacePage";
import PayrollPage from "@/pages/PayrollPage";
import PermitsLocatesPage from "@/pages/PermitsLocatesPage";
import InformationPage from "@/pages/InformationPage";
import BillingPage from "@/pages/BillingPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import AssetsPage from "@/pages/AssetsPage";
import AppointmentsCalendarPage from "@/pages/AppointmentsCalendarPage";
import OwnerLabPage from "@/pages/OwnerLabPage";
import ProjectActivityHistoryPage from "@/pages/ProjectActivityHistoryPage";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/" element={<Navigate replace to="/dashboard" />} />
              <Route path="/dashboard" element={<ExceptionDesk />} />
              <Route path="/ai-assistant" element={<GuardedRoute permission="ai_assistant:use" feature="ai_assistant"><ActionAiAssistantPage /></GuardedRoute>} />
              <Route
                path="/projects/:projectId"
                element={<GuardedRoute permission="operations:read"><ProjectAcceptancePage /></GuardedRoute>}
              />
              <Route
                path="/active-jobs/:jobId"
                element={<GuardedRoute permission="operations:read"><ActiveJobWorkspacePage /></GuardedRoute>}
              />
              <Route
                path="/master-project-board"
                element={<MasterBoardPage />}
              />
              <Route path="/manager-board" element={<GuardedRoute blockRoles={["supervisor"]}><ManagerBoard /></GuardedRoute>} />
              <Route path="/closed-projects" element={<GuardedRoute blockRoles={["supervisor"]}><ClosedProjectsPage /></GuardedRoute>} />
              <Route path="/deleted-projects" element={<GuardedRoute roles={["owner_admin"]}><DeletedProjectsPage /></GuardedRoute>} />
              <Route path="/invoices" element={<GuardedRoute permission="billing:read" feature="billing"><InvoiceWorkspace /></GuardedRoute>} />
              <Route
                path="/platform/companies"
                element={<PlatformCompaniesPage />}
              />
              <Route
                path="/platform/production-health"
                element={<PlatformCompaniesPage initialTab="runtime-health" />}
              />
              <Route
                path="/platform/access-studio"
                element={<PlatformCompaniesPage initialTab="access-studio" />}
              />
              <Route path="/production" element={<GuardedRoute blockRoles={["supervisor", "project_manager"]} feature="production_tracker"><ProductionTrackerPage /></GuardedRoute>} />
              <Route path="/change-password" element={<PasswordChangePage />} />
              <Route path="/users" element={<GuardedRoute permission="users:manage"><UserManagementPage /></GuardedRoute>} />
              <Route path="/my-work" element={<Navigate replace to="/master-project-board" />} />
              <Route path="/action-queue" element={<GuardedRoute blockRoles={["supervisor"]}><ActionQueuePage /></GuardedRoute>} />
              <Route path="/project-activity" element={<GuardedRoute blockRoles={["supervisor"]}><ProjectActivityHistoryPage /></GuardedRoute>} />
              <Route path="/workspace" element={<Navigate replace to="/dashboard" />} />
              <Route path="/communications" element={<CommunicationLogWorkspacePage />} />
              <Route path="/payroll" element={<GuardedRoute permission="payroll:manage" feature="payroll"><PayrollPage /></GuardedRoute>} />
              <Route path="/permits-locates" element={<GuardedRoute blockRoles={["supervisor"]}><PermitsLocatesPage /></GuardedRoute>} />
              <Route path="/information" element={<GuardedRoute roles={["owner_admin", "office_admin"]}><InformationPage /></GuardedRoute>} />
              <Route path="/billing" element={<GuardedRoute permission="billing:read" feature="billing"><BillingPage /></GuardedRoute>} />
              <Route path="/analytics" element={<GuardedRoute permission="analytics:read" feature="analytics"><AnalyticsPage /></GuardedRoute>} />
              <Route path="/assets" element={<GuardedRoute permission="assets:manage"><AssetsPage /></GuardedRoute>} />
              <Route path="/appointments" element={<GuardedRoute blockRoles={["supervisor"]}><AppointmentsCalendarPage /></GuardedRoute>} />
              <Route path="/schedule" element={<Navigate replace to="/master-project-board" />} />
              <Route path="/owner-lab" element={<GuardedRoute roles={["owner_admin"]} feature="owner_lab"><OwnerLabPage /></GuardedRoute>} />
              <Route path="/architecture" element={<Navigate replace to="/dashboard" />} />
              <Route path="*" element={<Navigate replace to="/dashboard" />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;
